const getGameBaseHref = (slug, { id, titleURL }) => (
  `/${slug}/games/${id}-${titleURL}`
);

export const getGameLaunchHref = (slug, game, category, gameSearchCategoryId) => {
  const queryParams = new URLSearchParams();

  if (category) queryParams.append('category', category);
  if (gameSearchCategoryId) queryParams.append('game_search_category_id', gameSearchCategoryId);

  const queryString = queryParams.toString();

  return `${getGameBaseHref(slug, game)}/launch${queryString ? `?${queryString}` : ''}`;
};

export const getGameInfoHref = getGameBaseHref;
